export default __webpack_public_path__ + "static/media/143.24ae4794.jpg";